<template>
    <div v-if="user" class="profile__detail">
        <v-text-field v-model="newUsername" placeholder="Vorname" type="text"></v-text-field>
        <v-text-field v-if="providerId == 'password'" v-model="newEmail" placeholder="E-Mail-Adresse" type="text"></v-text-field>
        <small v-else>Die Email-Adresse kann nicht geändert werden, da du über {{ providerId }} angemeldet bist.</small>
        <small v-if="providerId == 'password'"><router-link to="/password-change">Passwort ändern</router-link></small>
        <div class="list">
			<div v-if="providerId != 'password'" class="list__item">
				<div class="list__item__content">
					<div class="list__item__label list__item__value--light">
						Email
					</div>
				</div>
				<div class="list__item__value list__item__value--light">
					{{ oldEmail }}
				</div>
				<img @click="copyEmail(oldEmail)" src="@/assets/ic_16_copy.svg" style="margin-left: 8px;">
			</div>
			<div class="list__item">
				<div class="list__item__content">
					<div class="list__item__label list__item__value--light">
						ID
					</div>
				</div>
				<div class="list__item__value list__item__value--light">
					{{ user.uid }}
				</div>
				<img @click="copyId(user.uid)" src="@/assets/ic_16_copy.svg" style="margin-left: 8px;">
			</div>
            <div class="list__item">
				<div class="list__item__content">
					<div class="list__item__label list__item__value--light">
						Version
					</div>
				</div>
				<div class="list__item__value list__item__value--light">
					{{ appVersion }}
				</div>
			</div>
            <div v-if="showDebugInfo" class="list__item">
				<div class="list__item__content">
					<div class="list__item__label list__item__value--light">
						Installation Id
					</div>
				</div>
				<div class="list__item__value list__item__value--light">
					{{ installationId }}
				</div>
                <img @click="copyId(installationId)" src="@/assets/ic_16_copy.svg" style="margin-left: 8px;">
			</div>
            <div v-if="showDebugInfo" class="list__item">
				<div class="list__item__content">
					<div class="list__item__label list__item__value--light">
						Device token
					</div>
				</div>
				<div class="list__item__value list__item__value--light">
					{{ displayDeviceToken }}
				</div>
                <img @click="copyId(deviceToken)" src="@/assets/ic_16_copy.svg" style="margin-left: 8px;">
			</div>
        </div>
        <v-btn v-if="isIOS && showDebugInfo" class="button button--secondary" @click="clearCache" style="margin-bottom: 0">Cache leeren</v-btn>

        <small v-show="retryWithPassword" class="text-center" style="margin-bottom: 10px;">Bitte gib zur Bestätigung der Änderung noch dein Passwort ein.</small>
        <v-text-field v-show="retryWithPassword" v-model="password" placeholder="Passwort" type="password" required></v-text-field>

        <v-btn class="button button--primary" @click="saveSettingsCheck">Übernehmen</v-btn>
    </div>
</template>
<script>
import router from '@/router';
import firebase from 'firebase';
import { copyTextToClipboard, postToIosHandler } from  '@/sportlerplus-helper';
import { isSportplatzMediaEmail } from '@/utils/internalUser';

export default {
    name: 'SettingsLogin',
    data() {
        return {
            oldUsername: null,
            oldEmail: null,
            newUsername: null,
            newEmail: null,
            user: null,
            providerId: null,
            retryWithPassword: false,
            password: null
        }
    },
   methods: {
        init(){
            this.user = firebase.auth().currentUser;
            if (this.user) {
                this.newUsername = this.user.displayName;
                this.newEmail = this.user.email;
                this.oldUsername = this.user.displayName;
                this.oldEmail = this.user.email;
                this.providerId = this.user.providerData[0].providerId
            }
        },
        copyEmail(text) {
            copyTextToClipboard(text, "Email-Adresse wurde kopiert!");
        },
        copyId(text) {
            copyTextToClipboard(text, "ID wurde in Zwischenablage kopiert!");
        },
        clearCache() {
            postToIosHandler('clearCacheMessageHandler', {"bogus": "value"});
        },
        signInAgain() {
            let provider;
            if (this.providerId === "google.com")
                provider = new firebase.auth.GoogleAuthProvider();
            else if (this.providerId === "facebook.com")
                provider = new firebase.auth.FacebookAuthProvider();
            else if (this.providerId === "apple.com") {
                provider = new firebase.auth.OAuthProvider('apple.com');
                provider.addScope('email');
                provider.addScope('name');
            }
            firebase.auth().signInWithPopup(provider).then(() => {
                this.saveSettings();
            });
        },
        saveSettingsCheck() {
            if (this.retryWithPassword && (this.providerId == "password")) {
                var credentials = firebase.auth.EmailAuthProvider.credential(
                    this.user.email,
                    this.password
                );
                this.user.reauthenticateWithCredential(credentials).then( () => this.saveSettings() );
            }
            else {
                this.saveSettings();
            }
        },
        saveSettings() {
            let changes = [];
            if (this.newUsername !== this.oldUsername) {
                changes.push(
                    this.user.updateProfile({
                        displayName: this.newUsername,
                    }).catch(function(error) {
                        // An error happened.
                        console.log(error);
                    }));
            }

            if (this.newEmail !== this.oldEmail) {
                changes.push(
                    this.user.updateEmail(this.newEmail).catch(function(error) {
                        // An error happened.
                        console.log(error);
                    }));
            }

            Promise.all(changes).then( () => router.go(-1) ).catch( () => {
                if (this.providerId == "password") {
                    this.retryWithPassword = true;
                }
                else {
                    this.signInAgain();
                }
            });
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        appVersion() {
            return this.$store.getters.getVersion;
        },
        installationId() {
            return this.$store.getters.getInstallationId;
        },
        deviceToken() {
            return this.$store.getters.getDeviceToken;
        },
        displayDeviceToken() {
            let d = this.deviceToken;
            if (d && d.length > 20) {
                return d.slice(0, 20) + "…";
            }
            return "";
        },
        showDebugInfo() {
            if (!this.user) { return false; }
            return isSportplatzMediaEmail(this.user.email);
        },
        isIOS() {
            return (window.webkit && window.webkit.messageHandlers);
        }
    }
}
</script>

<style lang="scss">
    .profile__detail {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-top: 17px;
        width: 100%;
        max-width: 480px;
        margin: 16px auto 0;

        .button {
            margin-top: auto;
            position: sticky;
            bottom: 16px;
        }
    }
</style>